import React from 'react';
import '../../App.css';
import '../../bootstrap.css';
import * as Database from '../../helpers/Database';
const _ = require('lodash');

export const NOTES_TYPE = {
  Coach: 'coach', // this is the hand-off
  DataEntry: 'dataEntry'
}

export default class ReminderDay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notesBoxExpanded: false,
      notesType: this.props.dataEntryMode ? NOTES_TYPE.DataEntry : NOTES_TYPE.Coach
    }

    this._reinitNotesListener(this.props.userId);
  }

  _reinitNotesListener(userId) {
    if (this.unsubNotesListener) {
      this.unsubNotesListener();
    }
    this.unsubNotesListener = Database.initNotesListeners(userId, (data, id) => {
      // Call setState whenever callback gets invoked so when coaches or DEP modify
      // notes, they'll see it update in real time. Can be good for collab.
      if (id === NOTES_TYPE.Coach) {
        this.setState({
          scratchpad: data.content
        });
      } else if (id === NOTES_TYPE.DataEntry) {
        this.setState({
          userNotesDataEntry: data.content
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userId != this.props.userId) {
      this.setState({
        scratchpad: '',
        userNotesDataEntry: '',
      });
      this._reinitNotesListener(nextProps.userId);
    }
  }

  toggleNotesBox() {
    this.setState({ notesBoxExpanded: !this.state.notesBoxExpanded });
  }

  scratchpadChange = (e) => {
    // Call setState here even though we'll setState again in Database.initNotesListeners callback.
    // Reason: If we wait too long cursor will jump to the end after that callback gets invoked and we also can't to stuff like ctrl+z after that happens.
    this.setState({
      scratchpad: e.target.value
    });

    Database.setUserNotes(this.props.userId, NOTES_TYPE.Coach, {
      content: e.target.value
    });
  }

  notesDataEntryChange = (e) => {
    // Call setState here even though we'll setState again in Database.initNotesListeners callback.
    // Reason: If we wait too long cursor will jump to the end after that callback gets invoked and we also can't to stuff like ctrl+z after that happens.
    this.setState({
      userNotesDataEntry: e.target.value
    });
    
    Database.setUserNotes(this.props.userId, NOTES_TYPE.DataEntry, {
      content: e.target.value
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.dataEntryMode != prevProps.dataEntryMode) {
      this.setState({
        notesType: this.props.dataEntryMode ? NOTES_TYPE.DataEntry : NOTES_TYPE.Coach
      })
    }
  }

  componentWillUnmount() {
    if (this.unsubNotesListener) {
      this.unsubNotesListener();
    }
  }

  handleOptionChange = (e) => {
    //this.clearLoggingInputs();
    this.setState({
      notesType: e.target.value
    });
  }

  render() {
    let radioButtons =
      <form style={{ display: 'inline-block', marginLeft: '10px' }}>
        <input type="radio" value={NOTES_TYPE.Coach} checked={this.state.notesType === NOTES_TYPE.Coach}
          onChange={this.handleOptionChange} />&nbsp;<b>Coach Notes</b>
        <input style={{ marginLeft: '10px' }} type="radio" value={NOTES_TYPE.DataEntry}
          checked={this.state.notesType === NOTES_TYPE.DataEntry} onChange={this.handleOptionChange} />&nbsp;<b>Data Entry Notes</b>
      </form>;

    let notesBox;
    if (this.state.notesType === NOTES_TYPE.DataEntry) {
      notesBox = <textarea rows={this.state.notesBoxExpanded ? '30' : "8"}
        style={{ width: "-webkit-fill-available", fontSize: '12px', padding: '10px', margin: "10px" }}
        value={this.state.userNotesDataEntry ? this.state.userNotesDataEntry : ''} onChange={this.notesDataEntryChange}
      ></textarea>;
    } else {
      notesBox = <textarea rows={this.state.notesBoxExpanded ? '30' : "8"}
        style={{ width: "-webkit-fill-available", fontSize: '12px', padding: '10px', margin: "10px" }}
        value={this.state.scratchpad ? this.state.scratchpad : ''} onChange={this.scratchpadChange}
      ></textarea>;
    }

    let notesContainer =
      <div style={{ border: 'solid 1px', padding: '10px', margin: '10px', backgroundColor: 'mintcream' }}>
        <div>
          {radioButtons}
          <div>
            <input type='submit' className='btn btn-secondary pt-1 pb-0 float-right'
              style={{ marginRight: '10px' }}
              onClick={this.toggleNotesBox.bind(this)} value='Expand'
            />
          </div>
        </div>
        {notesBox}
      </div>;

    return (
      <span>
        {notesContainer}
      </span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/NotesBox2.js